// 🔔 알림톡 템플릿 매핑 상수
import type { TemplateType } from '../../orderDetail/types';

// 🔗 API 엔드포인트
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api-4iuywcitfq-uc.a.run.app';

// 🔔 상태별 알림톡 템플릿 매핑
export const STATUS_TO_ALERT_TEMPLATE: Record<string, TemplateType | null> = {
  '접수완료': '신청완료',
  '택배접수': null,
  '입고완료': '입고완료',
  '검수중': null, // 검수중에는 별도 알림 없음
  '가격안내': '가격안내',
  '입금대기': null, // 입금 대기 시에는 별도 알림 없음
  '부분완료': null, // 부분 완료 시에는 별도 알림 없음
  '반송': '반송',
  '완료': '완료',
};